import { Button } from "@chakra-ui/react";
import { colors, customEvent, EventPathType, EventTriggerAndTargetType } from "goi_common";
import { ReactNode, useMemo } from "react";

function HeaderButton({
  path = "gnb",
  type,
  eventTrigger,
  onClick,
  children,
}: {
  path: keyof typeof EventPathType;
  type: string;
  eventTrigger: EventTriggerAndTargetType[EventPathType];
  onClick: () => void;
  children: ReactNode;
}) {
  const btnCss = useMemo(() => {
    if (type === "ORANGE") {
      return {
        padding: "6px 8px",
        backgroundColor: colors.orange650,
        color: "white",
        borderRadius: "5px",
      };
    } else if (type === "BLACK") {
      return {
        padding: "6px 12px",
        backgroundColor: colors.black,
        color: "white",
        borderRadius: "5px",
      };
    } else if (type === "RED") {
      return {
        padding: "5px 12px",
        backgroundColor: "#FFE3E3",
        color: "#FF6060",
        borderRadius: "6px",
        height: "32px",
      };
    }
  }, [type]);

  return (
    <Button
      css={btnCss}
      onClick={() => {
        customEvent({
          newGtm: {
            path: "gnb",
            trigger_and_target: eventTrigger,
          },
        });
        onClick();
      }}
    >
      <span className="body_14_m">{children}</span>
    </Button>
  );
}

export default HeaderButton;
